import { useEffect } from 'react';

import 'bundles/crm/lite_crm_overrides/index_styles.scss';
import 'bundles/crm/lite_crm_overrides/map_styles.scss';

export function useEdgeCrmStyleOverrides() {
  useEffect(() => {
    document.body.classList.add('with-edge-crm-overrides');
  }, []);
}
